// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2qWCd","errorLogs":"styles_errorLogs__3EaEn"};